import { FC, useEffect, useState, useRef } from 'react';
import { Typography } from '@mui/material';
import StructuredModal from '../../../../components/structuredModal/structuredModal';
import { useAdmissionsService } from '../../../../../apis/admissions/useAdmissionsService';
import { TStudentFees } from '../../../../../apis/admissions/adminssionFees.interfaces';
import StudentFeeForm from './studentFeeForm.view';
import { useTranslation } from '../../../../../hooks/useTranslationHook';
type EditStudentFeeModalProps = {
  isOpen: boolean;
  onClose: () => void;
  selectedStudent: string | null;
};

const EditStudentFeeModal: FC<EditStudentFeeModalProps> = ({
  isOpen,
  onClose,
  selectedStudent,
}) => {
  const { translateText } = useTranslation();
  const { getStudentFeesByUserId } = useAdmissionsService();
  const [errorMessage, setErrorMessage] = useState('');
  const [studentFees, setStudentFees] = useState<TStudentFees | null>(null);

  // Create a ref to hold the form submit function
  const formSubmitRef = useRef<(() => void) | null>(null);

  const onSaveFeeClickHandler = () => {
    // Call the form submit function when Save Fee is clicked
    if (formSubmitRef.current) {
      formSubmitRef.current();
    }
  };

  const onSubmitFeeData = (data: TStudentFees) => {
    // TODO: Implement fee update logic
    console.log(data);
    setErrorMessage('');
    onClose();
  };

  useEffect(() => {
    if (selectedStudent) {
      getStudentFeesByUserId(selectedStudent).then((data) => {
        setStudentFees(data);
      });
    }
  }, [selectedStudent, getStudentFeesByUserId]);

  return (
    <StructuredModal
      isOpen={isOpen}
      onClose={onClose}
      title={translateText('students.fees.editStudentFee')}
      drawerWidth="70vw"
      footerPositiveAction={onSaveFeeClickHandler}
      footerPositiveActionText={translateText('students.fees.saveFee')}
      footerMessage={
        errorMessage ? (
          <Typography color="error" variant="body2">
            {errorMessage}
          </Typography>
        ) : (
          ''
        )
      }
    >
      <StudentFeeForm
        studentFees={studentFees}
        onSubmit={onSubmitFeeData}
        submitRef={formSubmitRef}
      />
    </StructuredModal>
  );
};

export default EditStudentFeeModal;
